import { mapBaseVideo } from './BaseVideo.mappers';
export const mapSecureVideo = (file, baseFile) => {
  const baseVideo = mapBaseVideo(file, baseFile);
  return {
    mediaType: 'secure_video',
    ...baseVideo,
    height: null,
    width: null,
    videoPreviewUrls: [] // no video preview urls for secure videos
  };
};
//# sourceMappingURL=SecureVideo.mappers.js.map